/**
 * `/stock-list`: the Ryerson Stock List landing page, Ryerson build only. Two things happen here:
 * - `components/StockList/Hero.tsx` sells the printed copy: pick a quantity and "Order Now" goes
 *   to `/stock-list/purchase/?qty=<n>`, the start of the PayPal purchase.
 * - `components/StockList/Body.tsx` gives away the digital PDFs in exchange for a lead form posted
 *   to the Common API.
 *
 * Copy and SEO head come from `content/ryerson/stock-list.ts`, which is also in the site search
 * index.
 */
import React from "react";
import Hero from "@components/StockList/Hero";
import Body from "@components/StockList/Body";
import { useApplication } from "@ryerson/frontend.application";
import MetaHead from "@components/Shared/model/MetaHead";
import { MetaObject } from "@content/ryerson/stock-list";
import { BodyContent } from "@content/ryerson/stock-list";
import { HeroContent } from "@content/ryerson/stock-list";
import { allContentfulHeaderCalls, HeaderPageProps } from "@ryerson/frontend.contentful";
import { getHeaderData } from "@components/NextLayouts/nextUtilities";
import HeaderLayout from "@components/NextLayouts/HeaderLayout";

/**
 * Builds the page on the Ryerson build only and fetches the Contentful header, locations and
 * footer data for `HeaderLayout`.
 */
export const getStaticProps = async () => {
	if (process.env.NEXT_PUBLIC_COMPANY !== "ryerson") {
		return { notFound: true }; // tells Next.js to skip page generation and return 404
	}

	return await allContentfulHeaderCalls();
};

/** The `/stock-list` page; see the file header. */
const Page: React.FC<HeaderPageProps> = (props) => {
	const {
		localization: { language },
	} = useApplication();

	return (
		<HeaderLayout {...getHeaderData(props)}>
			<MetaHead content={MetaObject[language]} />
			<Hero content={HeroContent[language]} />
			<Body content={BodyContent[language]} />
		</HeaderLayout>
	);
};

export default Page;
